import React from 'react';
import PropTypes from 'prop-types';
import DeleteRelatedButton from 'pages/products/productRelated/buttons/DeleteRelatedButton';
import FieldTitle from 'components/aor/FieldTitle';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import NoResults from 'components/form/styling/NoResults';
import Table from 'components/ui/table/Table';
import TableBodyCell from 'components/table/TableBodyCell';
import TableRow from 'components/ui/table/TableRow';
import TextField from 'components/show/TextField';
import SingleDataContainer from 'containers/Data/SingleDataContainer';
import SubcategoryField from 'pages/products/productRelated/SubCategoryField';
import styled from 'styled-components';
import utils from 'helpers/utils';
import { fetchProductAccumulated } from 'store/actions/products/fetchProducts';

const StyledDeleteIcon = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

const ProductsTable = (props) => {
    const {
        data,
        handleRemove,
        resource,
        source,
        noResultsLabel,
    } = props;

    if (utils.isEmpty(data[source])) {
        return <NoResults label={ noResultsLabel } />;
    }

    return (
        <Table responsive='scroll'>
            <TableRow>
                <HeaderColumn style={ { width: '40%' } } >
                    <FieldTitle
                        label='resources.products.fields.title'
                        source='title'
                        resource={ resource }
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '25%' } }>
                    <FieldTitle
                        label='resources.products.fields.category_id'
                        source='category_id'
                        resource={ resource }
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '25%' } }>
                    <FieldTitle
                        label='resources.products.fields.subcategory_id'
                        source='subcategory_id'
                        resource={ resource }
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '10%' } }>&nbsp;</HeaderColumn>
            </TableRow>

            { utils.map(data[source], function (productId) {

                return (
                    <SingleDataContainer
                        action={ fetchProductAccumulated }
                        id={ productId }
                        key={ `${ source }-${ productId }` }
                        resource={ resource }
                    >
                        { (renderProps) => {
                            const product = renderProps.data;

                            return (
                                <TableRow>
                                    <TableBodyCell
                                        field={ <TextField value={ product.title } /> }
                                        record={ product }
                                        source='title'
                                    />

                                    <TableBodyCell
                                        field={ <TextField value={ product.relationships.category.data.name } /> }
                                        record={ product }
                                        source='category.name'
                                    />

                                    <TableBodyCell
                                        field={
                                            <SubcategoryField
                                                id={ product.subcategory_id }
                                                parentId={ product.category_id }
                                            />
                                        }
                                        record={ product }
                                        source='subcategory_id'
                                    />

                                    <TableBodyCell
                                        field={
                                            <StyledDeleteIcon>
                                                <DeleteRelatedButton
                                                    handleRemove={ () => {
                                                        return handleRemove(productId, source);
                                                    } }
                                                />
                                            </StyledDeleteIcon>
                                        }
                                        record={ product }
                                        resource={ resource }
                                    />
                                </TableRow>
                            );
                        } }
                    </SingleDataContainer>
                );
            }) }
        </Table>
    );
};

ProductsTable.defaultProps = {
    noResultsLabel: 'resources.products.related.no_results',
    resource: 'products',
    source: 'products',
};

ProductsTable.propTypes = {
    data: PropTypes.object.isRequired,
    handleRemove: PropTypes.func.isRequired,
    noResultsLabel: PropTypes.string,
    resource: PropTypes.string,
    source: PropTypes.string,
};

export default ProductsTable;



// WEBPACK FOOTER //
// ./src/pages/pointsofinterest/products/ProductsTable.js